function Screen(props) {
  const { style } = props;
  const _style = style ?? "flex-grow";
  return <div className={_style}>{props.children}</div>;
}

export default Screen;
